const actions = {
  fetchPending: 'LOADING::PASSES',
  fetchPasses: 'FETCH::PASSES',
  setPasses: 'SET::PASSES',
  setVisitPassDetails: 'SET::PASS_DETAILS'
}

export const setPassDetails = (state, actionRequired) => ({ type: actions.setVisitPassDetails, passDetails: state, actionRequired })

export default actions



// WEBPACK FOOTER //
// ./src/store/passes/actions.js